module.exports = __webpack_public_path__ + "img/food.7d68c6b1.jpg";